/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type NegativeIntentV2FilterConfigColumn =
  (typeof NegativeIntentV2FilterConfigColumn)[keyof typeof NegativeIntentV2FilterConfigColumn];

export const NegativeIntentV2FilterConfigColumn = {
  negative_user_intent_v2: 'negative_user_intent_v2',
} as const;
